import React from 'react';

export interface DocumentPreviewProps {
  /** Display name for the document */
  documentName: string;
  /** URL to the PDF (e.g. from API document.file_url). When set, PDF is shown in an iframe */
  fileUrl?: string | null;
  /** Optional class name for the container */
  className?: string;
  /** Height of the preview area (default 400px) */
  height?: number | string;
}

export const DocumentPreview: React.FC<DocumentPreviewProps> = ({
  documentName,
  fileUrl,
  className = '',
  height = 400,
}) => {
  const hasPdf = Boolean(fileUrl);

  return (
    <div
      className={`rounded-xl border border-slate-200 dark:border-slate-700 overflow-hidden bg-slate-50 dark:bg-slate-900/40 flex flex-col ${className}`}
      style={{ minHeight: typeof height === 'number' ? `${height}px` : height }}
    >
      <div className="px-3 py-2 border-b border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/50">
        <h2 className="text-sm font-semibold text-slate-800 dark:text-slate-100">Document preview</h2>
      </div>
      <div
        className="flex-1 flex flex-col min-h-0 relative"
        style={{ height: typeof height === 'number' ? height : undefined }}
      >
        {hasPdf ? (
          <iframe
            key={fileUrl ?? 'pdf'}
            src={fileUrl ?? undefined}
            title={documentName}
            className="w-full flex-1 min-h-0 border-0 bg-white dark:bg-slate-900"
          />
        ) : (
          <div className="flex-1 flex items-center justify-center p-6 text-center">
            <div>
              <p className="text-sm font-medium text-slate-700 dark:text-slate-200 mb-1">Preview not available</p>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                This document has no file uploaded yet. You can still sign below to record your signature.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
